<div class="wrapper">
    <i class="fas fa-times clear-button" matTooltip="Limpar campo" (click)="clear()" (keyDown)="clear()"></i>

    <input type="text" class="datetime form-control mr-1" name="dateTimePicker"
           [ngModel]="$value()"
           [disabled]="true"
           [ngxMatDatetimePicker]="dateTimePicker"
           (dateInput)="onChange($event.value)"
    >

    <mat-datepicker-toggle matSuffix [for]="dateTimePicker"></mat-datepicker-toggle>

    <ngx-mat-datetime-picker #dateTimePicker
                             [showSpinners]="true"
                             [showSeconds]="true"
                             [defaultTime]="[12,00,00]"
                             [disabled]="$disabled()"
    >
        <ngx-mat-datepicker-actions>
            <button mat-button ngxMatDatepickerCancel class="btn btn-outline-danger mr-2">Cancelar</button>
            <button mat-button ngxMatDatepickerApply class="btn btn-outline-primary">Aplicar</button>
        </ngx-mat-datepicker-actions>
    </ngx-mat-datetime-picker>
</div>
